import React, { useState } from "react"
import PropTypes from 'prop-types'
import { Link, useHistory } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useHotkeys } from 'react-hotkeys-hook';

const ShortCutDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const history = useHistory()
  const [menu, setMenu] = useState(false)

  useHotkeys('alt+s,option+s', ()=> {
    history.push('/add-sales');
  })
  useHotkeys('alt+e,option+e', ()=> {
    history.push('/add-purchase');
  })
  useHotkeys('alt+r,option+r', ()=> {
    history.push('/add-sales-payment');
  })
  useHotkeys('alt+i,option+i', ()=> {
    history.push('/add-purchase-payment');
  })
  useHotkeys('alt+a,option+a', ()=> {
    history.push('/view-sales-entries');
  })
  useHotkeys('alt+o,option+o', ()=> {
    history.push('/view-purchase-entries');
  })

  const dropDownItems = [{
    clazz: 'bg-primary',
    title : 'New Sales Entry',
    sKey : 'Alt+S',
    link: '/add-sales'
  },
  {
    clazz: 'bg-primary',
    title : 'New Payment/Receipt',
    sKey : 'Alt+R',
    link: '/add-sales-payment'
  },
  {
    clazz: 'bg-primary',
    title : 'All Sales',
    sKey : 'Alt+A',
    link: '/view-sales-entries'
  },
  {
    clazz: 'bg-info',
    title : 'New Purchase Entry',
    sKey : 'Alt+E',
    link: '/add-purchase'
  },
  {
    clazz: 'bg-info',
    title : 'New Purchase Payment',
    sKey : 'Alt+I',
    link: '/add-purchase-payment'
  },
  {
    clazz: 'bg-info',
    title : 'All Purchases',
    sKey : 'Alt+O',
    link: '/view-purchase-entries'
  }]

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-dialpad" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> Shortcuts </h6>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {dropDownItems.map((each,i)=> (
              <Link to={each.link} className="text-reset notification-item" key={"sk"+i}>
                <div className="media">
                  <div className="avatar-xxs me-3">
                    <span className={"avatar-title rounded-circle font-size-10 "+each.clazz}>
                      {i+1}
                    </span>
                  </div>
                  <div className="media-body align-self-center shortcut-title">
                    {each.title}
                  </div>
                  <div>
                    {each.sKey}
                  </div>
                </div>
              </Link>
            )
            )}
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default (ShortCutDropdown)

ShortCutDropdown.propTypes = {
  t: PropTypes.any
}